import { createContext, useContext, useReducer, useEffect } from 'react'
import PropTypes from 'prop-types'
import Cookies from 'js-cookie'

const WishlistContext = createContext()
const initialState = Cookies.get('wishlist') ? JSON.parse(Cookies.get('wishlist')) : []

const wishlistReducer = (state, action) => {
  switch (action.type) {
    case 'ADD_TO_WISHLIST':
      return [...state, action.payload]
    case 'REMOVE_FROM_WISHLIST':
      return state.filter((item) => item.id !== action.payload.id)
    default:
      return state
  }
}

export const WishlistProvider = ({ children }) => {
  const [wishlist, dispatch] = useReducer(wishlistReducer, initialState)

  useEffect(() => {
    Cookies.set('wishlist', JSON.stringify(wishlist), { 
      expires: 7,
      sameSite: 'None',
      secure: true
    })
  }, [wishlist])

  const addToWishlist = item => { dispatch({ type: 'ADD_TO_WISHLIST', payload: item }) }
  const removeFromWishlist = id => { dispatch({ type: 'REMOVE_FROM_WISHLIST', payload: { id } }) }
  const isInWishlist = productId => {return wishlist.some(item => item.id === productId)}

  return (
    <WishlistContext.Provider value={{ wishlist, addToWishlist, removeFromWishlist, isInWishlist }}>
      {children}
    </WishlistContext.Provider>
  )
}

WishlistProvider.propTypes = { children: PropTypes.node.isRequired }

export const useWishlist = () => useContext(WishlistContext)
